import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import {
  Container,
  Box,
  Button,
  Typography,
  Grid,
  Stack,
  Pagination,
  useTheme,
  useMediaQuery,
  Tabs,
  Tab,
  Divider,
  DialogContent,
  LinearProgress,
  Paper,
  Card,
  darken,
  IconButton
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FormTextField from "../form/FormTextField";
import { setAlert } from "../../features/slices/alertSlice";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import * as Constant from "../../features/constant";
import format from "date-fns/format";
import Image from "../common/Image";
import PaidIcon from '@mui/icons-material/Paid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import CloseIcon from "@mui/icons-material/Close";

import {
  useWithdrawMutation,
} from "../../features/api/transactionApiSlice";
import { useGetPromotionRecordMutation } from "../../features/api/bonusApiSlice";
import {
  useGetBankAccountsQuery,
  usePlayerBanksMutation,
  useGetWithdrawalDescQuery
} from "../../features/api/userApiSlice";
import FormSelect from "../form/FormSelect";


const Withdrawal = (props) => {
  const location = useLocation();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { t } = useTranslation();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const currentDate = new Date();
  const sevenDaysAgo = new Date();
  const [open, setOpen] = React.useState(false);
  const [openTnc, setOpenTnc] = React.useState(false);

  const [selectedBank, setSelectedBank] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [tempBank, setTempBank] = useState({});
  const [isLock, setIsLock] = useState(true);
  const isLightTheme = process.env.REACT_APP_IS_LIGHT_THEME === "true";
  const bankAccountUseMobile = process.env.REACT_APP_BANK_ACCOUNT_USE_MOBILE === "true";
  const bankBsbEnabled = process.env.REACT_APP_BANK_BSB_ENABLED === "true";
  const [totalTurnover, setTotalTurnover] = useState(0);
  const [validTurnover, setValidTurnover] = useState(0);
  const [withdrawalMinRolloverAmount, setWithdrawalMinRolloverAmount] = useState(0);

  const withdrawDetails =
    props.withdrawDetails || location.state?.withdrawDetails;

  const user =
    props.user || location.state?.user;

  const type = [
    { label: t("walletcard.transactionpage.all"), value: "All" },
    { label: t("walletcard.transactionpage.approved"), value: "Approved" },
    { label: t("walletcard.transactionpage.rejected"), value: "Rejected" },
    { label: t("walletcard.transactionpage.pending"), value: "Pending" },
  ];

  const [statusType, setStatusType] = useState(type[0].value);
  const [startDate, setStartDate] = useState(
    sevenDaysAgo.setDate(currentDate.getDate() - 7)
  );
  const [endDate, setEndDate] = useState(currentDate);
  const [offset, setOffset] = useState(0);

  const {
    data: bankDetails,
    isLoading: isBankDetailsLoading,
    isError: isBankDetailsError,
    isSuccess: isBankDetailsSuccess,
    error: bankDetailsError,
  } = useGetBankAccountsQuery();

  const {
    data: withdrawDesc,
    isLoading: iswithdrawDescLoading,
    isError: iswithdrawDescError,
    isSuccess: iswithdrawDescSuccess,
    error: withdrawDescError,
  } = useGetWithdrawalDescQuery();


  const [
    promotionRecord,
    result,
  ] = useGetPromotionRecordMutation();

  const [playerBanks] =
    usePlayerBanksMutation();


  useEffect(() => {
    if (!(endDate < startDate)) {
      let data = {
        criteria: {
          dateFrom: format(startDate, "dd-MM-yyyy"),
          dateTo: format(endDate, "dd-MM-yyyy"),
          status: statusType.toUpperCase(),
        },
        offset: offset,
      };
      promotionRecord(data).unwrap();
    }
  }, [startDate, endDate, statusType, offset]);

  useEffect(() => {
    const content = result?.data?.result?.content || [];

    const summary = content.reduce(
      (acc, item) => {
        acc.totalTurnover += Number(item.turnover || 0);
        acc.totalValidTurnover += Number(item.validTurnOver || 0);
        acc.count += 1;
        return acc;
      },
      { totalTurnover: 0, totalValidTurnover: 0, count: 0 }
    );
    setValidTurnover(summary.totalValidTurnover);
    setTotalTurnover(summary.totalTurnover);
    setWithdrawalMinRolloverAmount(user?.withdrawalRollover);


    const hasOngoing = content.some(item => item?.status === "ONGOING");

    const hasRemainingRollover = user?.withdrawalRollover > 0 && (user?.currentCredit || 0) < user?.withdrawalRollover;

    // If either condition is true, lock it
    if (hasOngoing || hasRemainingRollover) {
      setIsLock(true);
    } else {
      setIsLock(false);
    }
  }, [result])

  React.useEffect(() => {
    if (isBankDetailsSuccess && bankDetails?.result?.data[0]?.bankAccountName) {
      setValue("bankCode", bankDetails.result.data[0].bankCode)
      setValue("bankAccountName", bankDetails.result.data[0].bankAccountName)
      setValue("bankAccountNo", bankDetails.result.data[0].bankAccountNumber)
      setValue("bankAccountBsb", bankDetails.result.data[0].bankAccountBsb ?? "")
    }
  }, [isBankDetailsSuccess, bankDetails]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (bankDetails, index) => {
    setOpen(false);
    if (bankDetails !== null && bankDetails !== undefined) {
      setValue("bankCode", bankDetails?.bankCode)
      setValue("bankAccountName", bankDetails?.bankAccountName)
      setValue("bankAccountNo", bankDetails?.bankAccountNumber)
      setValue("bankAccountBsb", bankDetails?.bankAccountBsb ?? "")

      setSelectedBank(index);
    }
  };

  function SimpleDialog(props) {
    const { onClose, bankAccountName, open } = props;

    const handleClose = () => {
      onClose(bankAccountName, null);
    };

    const handleListItemClick = (bankDetails, index) => {
      onClose(bankDetails, index);
    };

    return (
      <Dialog onClose={handleClose} open={open} sx={{
        "& .MuiPaper-root": {
          bgcolor: theme.palette.background.paper,
          width: "100%",
          margin: 0,
          maxHeight: "70%",
          px: 4,
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,

          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#2a2a2a",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.primary.main,
            borderRadius: "8px",
          },
        }
      }}>
        <DialogTitle sx={{ color: process.env.REACT_APP_COLOR_TEXT }} >{t("walletcard.withdrawalpage.selectbank")}</DialogTitle>
        <List sx={{ pt: 0, marginX: 3 }}>
          {bankDetails?.result?.data?.map((data, index) => (
            <ListItem disableGutters key={data?.bankCode}>
              <ListItemButton onClick={() => handleListItemClick(data, index)} sx={{
                border: `1px solid ${index === selectedBank ? theme.palette.primary.main : '#ccc'}`,
                borderRadius: '5px',
                padding: '10px'
              }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <ListItemText
                    primary={<><b>{t('walletcard.withdrawalpage.bankaccountnumber')}: </b>{data?.bankAccountNumber}</>}
                    primaryTypographyProps={{
                      sx: { color: process.env.REACT_APP_COLOR_TEXT, fontSize: mobileView ? '13px' : '16px' }
                    }}
                  />
                  <ListItemText
                    primary={<><b>{t('walletcard.withdrawalpage.bankaccountname')}: </b> {data?.bankAccountName}</>}
                    primaryTypographyProps={{
                      sx: { color: process.env.REACT_APP_COLOR_TEXT, fontSize: mobileView ? '13px' : '16px' }
                    }}
                  />
                  <ListItemText
                    primary={
                      <>
                        <b>{t('walletcard.withdrawalpage.bankname')}: </b>
                        {data?.bankCode}
                      </>
                    }
                    primaryTypographyProps={{
                      sx: { color: process.env.REACT_APP_COLOR_TEXT, fontSize: mobileView ? '13px' : '16px' }
                    }}
                  />
                  {bankBsbEnabled && data?.bankAccountBsb && (
                    <ListItemText
                      primary={<><b>{t('walletcard.withdrawalpage.bankaccountbsb')}: </b>{data?.bankAccountBsb}</>}
                      primaryTypographyProps={{
                        sx: { color: process.env.REACT_APP_COLOR_TEXT, fontSize: mobileView ? '13px' : '16px' }
                      }}
                    />
                  )}
                </Box>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Dialog>
    );
  }

  const MobileTnc = () => {
    return (
      <Dialog onClose={() => { setOpenTnc(false) }} open={openTnc} sx={{
        "& .MuiPaper-root": {
          bgcolor: theme.palette.background.paper,
          mx: 3,
          width: "100%",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#2a2a2a",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.primary.main,
            borderRadius: "8px",
          },
        }
      }}>
        <DialogTitle fontWeight={"bold"}
          sx={{
            backgroundColor: theme.palette.primary.main || "white",
            py: 1,
            px: 1.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <Typography color={process.env.REACT_APP_COLOR_CONTRAST_TEXT || 'white'}
            fontSize={"small"}
            fontWeight={"bold"}
          > {"Terms and condition applied"}</Typography>

          <CloseIcon onClick={() => { setOpenTnc(false) }} />
        </DialogTitle>

        <DialogContent sx={{
          px: 3
        }}>
          <Typography dangerouslySetInnerHTML={{ __html: withdrawDesc?.result }}
          />
        </DialogContent>
      </Dialog>

    )
  }

  const hasMaxWithdraw =
    user?.maxWithdraw != null && !isNaN(user.maxWithdraw) && user.maxWithdraw > 0;

  const hasMinWithdraw =
    user?.minWithdraw != null && !isNaN(user.minWithdraw) && user.minWithdraw > 0;

  const maxAmount = hasMaxWithdraw
    ? user.maxWithdraw
    : user?.currentCredit;

  const minAmount = hasMinWithdraw
    ? user.minWithdraw
    : withdrawDetails?.withdrawalDetails?.minimum;

  let amountSchema = yup
    .number()
    .typeError(t("validation.amountonly"))
    .required(t("validation.amountisrequired"));

  if (!hasMaxWithdraw && minAmount != null && !isNaN(minAmount)) {
    amountSchema = amountSchema.min(minAmount, `Min ${minAmount}`);
  }

  if (maxAmount != null && !isNaN(maxAmount) && maxAmount > 0) {
    amountSchema = amountSchema.max(maxAmount, `Max ${maxAmount}`);
  }

  const withdrawalSchema = yup.object().shape({
    bankCode: yup.string().required(t("validation.bankname")),
    bankAccountName: yup.string().required(t("validation.bankaccname")),
    bankAccountNo: yup.string().required(t("validation.bankaccno"))
      .matches(/^[0-9]+$/, t("validation.bankaccnoonlynumbers")),
    bankAccountBsb: bankBsbEnabled
      ? yup.string().nullable().required(t("validation.bankbsb"))
      : yup.string().nullable(),
    amount: amountSchema,
  });

  const { control, handleSubmit, reset, getValues, setValue, clearErrors } = useForm({
    resolver: yupResolver(withdrawalSchema),
  });

  const [withdraw, { data, isLoading, isError, isSuccess, error }] =
    useWithdrawMutation();

  const [showWithdrawalComponents, setShowWithdrawalComponents] = useState(false);

  const withdrawalLimit = [
    { label: 'Minimum Amount', value: process.env.REACT_APP_CURRENCY_CODE + ' ' + (minAmount ?? withdrawDetails?.withdrawalDetails?.minimum) },
    { label: 'Maximum Amount', value: process.env.REACT_APP_CURRENCY_CODE + ' ' + (maxAmount ?? withdrawDetails?.withdrawalDetails?.maximum) },
    { label: 'Daily Maximum Amount', value: process.env.REACT_APP_CURRENCY_CODE + ' ' + withdrawDetails?.withdrawalDetails?.daily_amt },
    { label: 'Daily Limit', value: withdrawDetails?.withdrawalDetails?.daily_limit + ' Times' },

    // Add more data as needed
  ];

  const [tabValue, setTabValue] = useState(0);

  const withdrawalType = [];
  withdrawalType.push({ label: t("walletcard.depositpage.title") });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ pb: !mobileView ? 3 : 0, mt: !mobileView ? undefined : 3 }}>{children}</Box>}
      </div>
    );
  };

  const submitWithdrawal = async (data) => {
    let newData = {
      amount: data.amount,
      bankAccountName: data.bankAccountName,
      bankAccountNumber: data.bankAccountNo,
      bankCode: data.bankCode,
      ...(bankBsbEnabled && { bankAccountBsb: data.bankAccountBsb }),
    };

    try {
      if (isEditing) {
        await playerBanks(newData).unwrap();
      }

      await withdraw(newData).unwrap();

      // 3. Navigate home
      navigate(Constant.getPath('/'));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!isLoading && isSuccess) {
      dispatch(
        setAlert({
          isOpen: true,
          message: t("walletcard.withdrawalpage.successmessage"),
          variant: "success",
        })
      );
      // window.fbq('trackCustom', 'CompleteWithdrawal');
      reset();
    }
    if (!isLoading && isError) {
      dispatch(
        setAlert({
          isOpen: true,
          message: error?.data?.message,
          variant: "error",
        })
      );
      reset();
    }
  }, [isLoading, isSuccess, isError]);

  return (
    <Container sx={{
      background: !isLightTheme && mobileView ? theme.palette.background.paper : undefined,
      py: {
        xs: 10, sm: 0, md: 0, lg: 0
      },
      minHeight: mobileView ? "100vh" : undefined
    }}>
      <>
        <Container
          sx={{
            border: '1px solid',
            borderColor: isLock ? 'error.main' : 'success.main',
            backgroundColor: isLock ? 'rgba(211, 47, 47, 0.12)' : 'rgba(46, 125, 50, 0.12)',
            borderRadius: 4,
            py: 1.5,
            px: 2,
            mb: 2,
          }}>
          {!isLock ?
            <Typography
              fontSize={mobileView ? "medium" : undefined}
              color={"success.main"}
            >
              {t("walletcard.withdrawalpage.eligible")}
            </Typography>
            : (<>
              <Typography
                fontSize={mobileView ? "medium" : undefined}
                fontWeight={"bold"}
                color={'error.main'}
              >
                {t("walletcard.withdrawalpage.locked")}
              </Typography>

              <Typography
                fontSize={mobileView ? "medium" : undefined}
                color={'error.main'}
              >
                {t("walletcard.withdrawalpage.noteligible")}
              </Typography>
            </>)}
        </Container>

        {
          ((isLock && totalTurnover > 0 && validTurnover < totalTurnover) ||
            (withdrawalMinRolloverAmount > 0 && (user?.currentCredit || 0) < withdrawalMinRolloverAmount) ||
            user?.maxWithdraw > 0) && (
            <Paper
              elevation={0}
              sx={{
                px: 3,
                py: 2,
                mb: 2,
                borderRadius: 4,
                backgroundColor: process.env.REACT_APP_IS_LIGHT_THEME === 'true'
                  ? 'rgba(0, 0, 0, 0.05)'  // darken for light theme
                  : 'rgba(255, 255, 255, 0.05)', // lighten for dark theme
                border: "1px solid rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
              }}
            >

              {/* Total turnover */}
              {
                /* Added totalTurnover > 0 to the condition below */
                isLock && totalTurnover > 0 && validTurnover < totalTurnover && (
                  <Box>
                    <Box display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "small" : "medium"} color={theme.palette.primary.main || "white"}>
                        {t("walletcard.withdrawalpage.ongoingturnover")}
                      </Typography>
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "x-small" : "small"} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {
                          `${Math.min((validTurnover || 0) / (totalTurnover || 1) * 100, 100).toFixed(0)}%`
                        }
                      </Typography>
                    </Box>
                    <LinearProgress
                      variant="buffer"
                      value={Math.min(
                        ((validTurnover || 0) /
                          (totalTurnover || 1)) * 100,
                        100
                      )}
                      valueBuffer={100}
                      color="primary"
                      sx={{
                        my: 1,
                        width: "100%",
                        borderRadius: 5,
                        height: mobileView ? 5 : 10,
                        '& .MuiLinearProgress-bar2Buffer': {
                          backgroundColor: '#888',
                        },
                      }}
                    />
                    <Box display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "x-small" : "small"} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {`${validTurnover || 0} ${process.env.REACT_APP_CURRENCY_CODE}`}
                      </Typography>
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "x-small" : "small"} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {`${totalTurnover || 0} ${process.env.REACT_APP_CURRENCY_CODE}`}
                      </Typography>
                    </Box>
                  </Box>
                )
              }

              {/* Withdrawal Rollover */}
              {
                withdrawalMinRolloverAmount > 0 && (user?.currentCredit || 0) < withdrawalMinRolloverAmount && (
                  <Box>
                    <Box mt={1} display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}
                    >
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "small" : "medium"} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {t("walletcard.withdrawalpage.withdrawalrollover")}
                      </Typography>
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "x-small" : "small"} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {
                          `${Math.min(((user?.currentCredit || 0) / (withdrawalMinRolloverAmount || 1)) * 100, 100).toFixed(2)}%`
                        }
                      </Typography>
                    </Box>
                    <LinearProgress
                      variant="buffer"
                      value={Math.min(
                        ((user?.currentCredit || 0) /
                          (withdrawalMinRolloverAmount || 1)) * 100,
                        100
                      )}
                      valueBuffer={100}
                      color="primary"
                      sx={{
                        my: 1,
                        width: "100%",
                        borderRadius: 5,
                        height: mobileView ? 5 : 10,
                        '& .MuiLinearProgress-bar2Buffer': {
                          backgroundColor: '#888',
                        },
                      }}
                    />
                    <Box display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "x-small" : "small"} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {`${user?.currentCredit || 0} ${process.env.REACT_APP_CURRENCY_CODE}`}
                      </Typography>
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "x-small" : "small"} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {`${withdrawalMinRolloverAmount || 0} ${process.env.REACT_APP_CURRENCY_CODE}`}
                      </Typography>
                    </Box>
                  </Box>
                )
              }

              {/* Max Withdrawal */}
              {
                user?.maxWithdraw > 0 && (
                  <Box>
                    <Box mt={2} display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}
                    >
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "x-small" : "small"} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {t("walletcard.withdrawalpage.maxwithdraw")}
                      </Typography>
                      <Typography fontWeight={"bold"} fontSize={mobileView ? "x-small" : "small"} color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {
                          `${user?.maxWithdraw || 0} ${process.env.REACT_APP_CURRENCY_CODE}`
                        }
                      </Typography>
                    </Box>
                  </Box>
                )
              }
            </Paper>
          )
        }

        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <Box
              border={1}
              borderRadius={1}
              px={1}
              py={mobileView ? 0.6 : 1}
              borderColor="primary.main"
              width="100%"
              backgroundColor={theme.palette.primary.main}
            >
              <Grid
                container
                spacing={2}
                alignItems="center"
                wrap="nowrap"
              >
                <Grid item xs="auto" display="flex" justifyContent="center">
                  <PaidIcon sx={{ color: process.env.REACT_APP_COLOR_CONTRAST_TEXT || "white" }} />
                </Grid>

                <Grid item xs="auto">
                  <Typography
                    noWrap
                    color={process.env.REACT_APP_COLOR_CONTRAST_TEXT || "white"}
                    fontSize={mobileView ? "small" : undefined}
                  >
                    {t("walletcard.withdrawalpage.withdrawalbalance")} :
                  </Typography>
                </Grid>

                <Grid item xs="auto">
                  <Typography
                    noWrap
                    fontWeight="bold"
                    fontSize={mobileView ? "small" : undefined}
                    color={process.env.REACT_APP_COLOR_CONTRAST_TEXT || "white"}
                  >
                    {process.env.REACT_APP_CURRENCY_CODE} {user?.currentCredit || "0.00"}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

          </Grid>

        </Grid>
        <br />

        {
          mobileView ? (
            <Box px={1}>
              <Typography fontWeight="bold" fontSize={mobileView ? "small" : undefined}
                color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                {t("walletcard.withdrawaloption")}
              </Typography>

              <Tabs
                value={tabValue ?? 0}
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ style: { display: "none" } }}
                allowScrollButtonsMobile
                onChange={handleTabChange}
                sx={{
                  marginLeft: "1px"
                }}
              >
                {withdrawalType.map((type, index) => (
                  <Tab
                    icon={
                      <Image
                        width={!mobileView ? "95px" : "70px"}
                        height={!mobileView ? "75px" : "55px"}
                        src={process.env.REACT_APP_PROFILE + `/payment_method_` + index + `.png`}
                        sx={{
                          border:
                            index === tabValue && `2px solid ${theme.palette.primary.main}` ||
                            index !== tabValue && `1px solid ${theme.palette.button.faded.main}`,
                          borderRadius: "5px",
                          background: "rgba(255,255,255,0.25)",
                          py: !mobileView ? 1.5 : 1,
                          px: !mobileView ? 3 : 2,
                          flex: 0,
                        }}
                      />}
                    key={index}
                    label={
                      <Typography textTransform={"none"} textAlign={"center"} color={"primary"} fontWeight={600} fontSize={!mobileView ? "10px" : "9px"}>
                        {type.label}
                      </Typography>
                    }
                    sx={{
                      pl: 0,
                      pt: 0,
                      pb: 0
                    }}
                    disableRipple
                  />
                ))}
              </Tabs>
              <TabPanel value={tabValue} index={0}>
                <Box display="flex" flexDirection="column">
                  <div style={{ display: 'flex', justifyContent: 'flex-end', fontSize: '2px', gap: '15px' }}>
                    {
                      !isEditing ? (
                        <Button
                          variant="contained"
                          sx={{
                            minWidth: mobileView ? undefined : '60px',
                            width: mobileView ? '100%' : 'auto',
                            height: mobileView ? "25px" : "30px",
                            fontSize: mobileView ? "x-small" : "13px",
                            whiteSpace: 'nowrap'
                          }}
                          disabled={isLock}
                          onClick={() => {
                            setTempBank({
                              bankCode: getValues("bankCode"),
                              bankAccountName: getValues("bankAccountName"),
                              bankAccountNumber: getValues("bankAccountNo"),
                              bankAccountBsb: getValues("bankAccountBsb"),
                            });

                            setValue("bankCode", "");
                            setValue("bankAccountName", user?.username);
                            setValue("bankAccountNo", bankAccountUseMobile ? (user?.mobileNumber || "") : "");
                            setValue("bankAccountBsb", "");

                            setIsEditing(true);
                          }}
                        >
                          {t("walletcard.withdrawalpage.addbank")}
                        </Button>

                      ) : (
                        <Button
                          variant="outlined"
                          sx={{
                            minWidth: mobileView ? undefined : '60px',
                            width: mobileView ? '100%' : 'auto',
                            height: "30px",
                            fontSize: mobileView ? 'x-small' : '13px',
                            whiteSpace: 'nowrap',
                            color: process.env.REACT_APP_COLOR_TEXT

                          }}
                          onClick={() => {
                            setValue("bankCode", tempBank?.bankCode || "");
                            setValue("bankAccountName", tempBank?.bankAccountName || "");
                            setValue("bankAccountNo", tempBank?.bankAccountNumber || "");
                            setValue("bankAccountBsb", tempBank?.bankAccountBsb || "");

                            setTempBank({});
                            setIsEditing(false);
                            clearErrors(["bankCode", "bankAccountName", "bankAccountNo", "bankAccountBsb"]);
                          }}
                        >
                          {t('walletcard.withdrawalpage.cancel')}
                        </Button>
                      )}
                  </div>
                  <MobileTnc />
                  <SimpleDialog
                    bankaccountname={getValues("bankAccountName")}
                    open={open}
                    onClose={handleClose}
                  />
                  <form onSubmit={handleSubmit(submitWithdrawal)}>
                    {
                      !isEditing ? (
                        <FormTextField
                          label={t("walletcard.withdrawalpage.bankname")}
                          control={control}
                          controllerName="bankCode"
                          items={withdrawDetails?.banks
                            ?.filter((item) => item.status === "ACTIVE")
                            .map((item) => item.content)}
                          size="small"
                          disabled={!isEditing}
                          onChange={(e) => {
                            setValue("bankCode", e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: process.env.REACT_APP_COLOR_DISABLE || "#9e9e9e",
                            }
                          }}

                          InputProps={{
                            endAdornment: (
                              <Button
                                variant="contained"
                                onClick={handleClickOpen}
                                style={{
                                  WebkitTextFillColor: process.env.REACT_APP_COLOR_CONTRAST_TEXT
                                }}
                                sx={{
                                  display: isEditing ? "none" : undefined,
                                  height: mobileView ? '25px' : '30px',
                                  fontSize: mobileView ? 'x-small' : '12px',
                                  whiteSpace: 'nowrap',
                                  textTransform: "none",
                                  text: "none",
                                  color: process.env.REACT_APP_COLOR_CONTRAST_TEXT
                                }}
                                disabled={isLock}
                              >
                                {t("walletcard.withdrawalpage.selectbank")}
                              </Button>
                            ),
                          }}
                        />
                      )
                        : (
                          <FormSelect
                            label={t("walletcard.bankaccountpage.bankname")}
                            control={control}
                            onChange={(e) => {
                              setValue("bankCode", e.target.value);
                            }}
                            controllerName="bankCode"
                            items={bankDetails?.result?.bankConfigs
                              .map((item) => item.bankCode)}
                            size="small"
                          />
                        )
                    }

                    {getValues("bankCode") === "ESEWA" && (
                      <Typography color={process.env.REACT_APP_COLOR_TEXT || "white"} variant="body2">
                        {t("walletcard.withdrawalpage.esewaWarning")}<br />
                        {t("walletcard.withdrawalpage.esewaWarning2")}
                      </Typography>
                    )}
                    <FormTextField
                      label={t("walletcard.withdrawalpage.bankaccountname")}
                      control={control}
                      controllerName="bankAccountName"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: process.env.REACT_APP_COLOR_DISABLE || "#9e9e9e",
                        }
                      }}
                      size="small"

                    />
                    <FormTextField
                      label={t("walletcard.withdrawalpage.bankaccountnumber")}
                      control={control}
                      controllerName="bankAccountNo"
                      size="small"
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: process.env.REACT_APP_COLOR_DISABLE || "#9e9e9e",
                        }
                      }}
                      disabled={!isEditing || bankAccountUseMobile}
                    />
                    {bankBsbEnabled && (
                      <FormTextField
                        label={t("walletcard.withdrawalpage.bankaccountbsb")}
                        control={control}
                        controllerName="bankAccountBsb"
                        size="small"
                        sx={{
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: process.env.REACT_APP_COLOR_DISABLE || "#9e9e9e",
                          }
                        }}
                        disabled={!isEditing}
                      />
                    )}
                    <FormTextField
                      label={t("walletcard.withdrawalpage.amount")}
                      control={control}
                      controllerName="amount"
                      defaultValue={""}
                      disabled={isLock}
                      placeholder={`Min ${minAmount || 50.00}`}
                      size="small"
                    />
                    {
                      mobileView ? (
                        <>
                          <Typography mt={.7}
                            fontSize={"12px"}
                            fontWeight={"bold"}
                            color={theme.palette.primary.main || "white"}
                            textAlign={"center"}
                            sx={{
                              textDecoration: "underline"
                            }}
                            onClick={() => {
                              setOpenTnc(true);
                            }}
                          >Terms and conditions Applied*</Typography>
                          <Box
                            sx={{
                              position: "fixed",
                              bottom: 55,
                              left: 0,
                              right: 0,
                              px: 3,
                              zIndex: 2,
                              py: 1.2,
                              boxShadow: "0px -4px 14px rgba(0, 0, 0, 0.6)",
                              backgroundColor: process.env.REACT_APP_COLOR_BACKGROUND_PAPER,
                            }}
                          >
                            <Button
                              fullWidth={mobileView}
                              variant="contained"
                              type="submit"
                              disabled={isLoading || isLock}
                              sx={{
                                fontSize: mobileView ? "small" : undefined,
                                fontWeight: "bold",
                              }}
                            >
                              {t("walletcard.submit")}
                            </Button>
                          </Box>
                        </>
                      ) : (
                        <Box alignSelf="center"
                          mt={mobileView ? "20px" : "30px"}
                        >
                          <Button variant="contained" type="submit"
                            disabled={isLoading || isLock}
                            sx={{
                              width: mobileView ? "100%" : undefined,
                              fontSize: mobileView ? "small" : undefined,
                              fontWeight: "bold"
                            }}>
                            {t("walletcard.submit")}
                          </Button>
                        </Box>
                      )
                    }
                  </form>
                </Box>
              </TabPanel>
            </Box>
          ) : (
            <>
              <Box display={"flex"}>
                <Box display={"flex"} mr={3} flexDirection={"column"} flex={1}>
                  <Grid mt={1} container alignItems="center" spacing={2}>
                    <Grid item xs={2.5}>
                      <Typography fontWeight="bold" fontSize={"11px"}
                        color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {t("walletcard.withdrawaloption")}
                      </Typography>
                    </Grid>

                    <Grid item xs>
                      <Tabs
                        value={tabValue ?? 0}
                        variant="scrollable"
                        scrollButtons="auto"
                        TabIndicatorProps={{ style: { display: "none" } }}
                        allowScrollButtonsMobile
                        onChange={handleTabChange}
                        sx={{
                          marginLeft: "1px"
                        }}
                      >
                        {withdrawalType.map((type, index) => (
                          <Tab
                            icon={
                              <Image
                                width={!mobileView ? "95px" : "70px"}
                                height={!mobileView ? "75px" : "55px"}
                                src={process.env.REACT_APP_PROFILE + `/payment_method_` + index + `.png`}
                                sx={{
                                  border:
                                    index === tabValue && `2px solid ${theme.palette.primary.main}` ||
                                    index !== tabValue && `1px solid ${theme.palette.button.faded.main}`,
                                  borderRadius: "5px",
                                  background: "rgba(255,255,255,0.25)",
                                  py: !mobileView ? 1.5 : 1,
                                  px: !mobileView ? 3 : 2,
                                  flex: 0,
                                }}
                              />}
                            key={index}
                            label={
                              <Typography textTransform={"none"} textAlign={"center"} color={"primary"} fontWeight={600} fontSize={!mobileView ? "10px" : "9px"}>
                                {type.label}
                              </Typography>
                            }
                            sx={{
                              pl: 0,
                              pt: 0,
                              pb: 0
                            }}
                            disableRipple
                          />
                        ))}
                      </Tabs>
                    </Grid>
                  </Grid>

                  <TabPanel value={tabValue} index={0}>
                    <Box display="flex" flexDirection="column">
                      <div style={{ display: 'flex', justifyContent: 'flex-end', fontSize: '2px', gap: '15px' }}>
                        {
                          !isEditing ? (
                            <Button
                              variant="contained"
                              sx={{
                                minWidth: mobileView ? undefined : '60px',
                                width: mobileView ? '100%' : 'auto',
                                height: mobileView ? "25px" : "30px",
                                fontSize: mobileView ? "x-small" : "13px",
                                whiteSpace: 'nowrap'
                              }}
                              disabled={isLock}
                              onClick={() => {
                                setTempBank({
                                  bankCode: getValues("bankCode"),
                                  bankAccountName: getValues("bankAccountName"),
                                  bankAccountNumber: getValues("bankAccountNo"),
                                  bankAccountBsb: getValues("bankAccountBsb"),
                                });

                                setValue("bankCode", "");
                                setValue("bankAccountName", user?.username);
                                setValue("bankAccountNo", bankAccountUseMobile ? (user?.mobileNumber || "") : "");
                                setValue("bankAccountBsb", "");

                                setIsEditing(true);
                              }}
                            >
                              {t("walletcard.withdrawalpage.addbank")}
                            </Button>

                          ) : (
                            <Button
                              variant="outlined"
                              sx={{
                                minWidth: mobileView ? undefined : '60px',
                                width: mobileView ? '100%' : 'auto',
                                height: "30px",
                                fontSize: mobileView ? 'x-small' : '13px',
                                whiteSpace: 'nowrap',
                                color: process.env.REACT_APP_COLOR_TEXT
                              }}
                              onClick={() => {
                                setValue("bankCode", tempBank?.bankCode || "");
                                setValue("bankAccountName", tempBank?.bankAccountName || "");
                                setValue("bankAccountNo", tempBank?.bankAccountNumber || "");
                                setValue("bankAccountBsb", tempBank?.bankAccountBsb || "");

                                setTempBank({});
                                setIsEditing(false);
                                clearErrors(["bankCode", "bankAccountName", "bankAccountNo", "bankAccountBsb"]);
                              }}
                            >
                              {t('walletcard.withdrawalpage.cancel')}
                            </Button>
                          )}
                      </div>
                      <SimpleDialog
                        bankaccountname={getValues("bankAccountName")}
                        open={open}
                        onClose={handleClose}
                      />
                      <form onSubmit={handleSubmit(submitWithdrawal)}>

                        <Grid container alignItems="center" spacing={2}>
                          <Grid item xs={2.5}>
                            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                              fontSize: "11px"
                            }}>
                              {t("walletcard.withdrawalpage.bankname")}
                            </Typography>
                          </Grid>

                          <Grid item xs>
                            {
                              !isEditing ? (
                                <FormTextField
                                  control={control}
                                  controllerName="bankCode"
                                  items={withdrawDetails?.banks
                                    ?.filter((item) => item.status === "ACTIVE")
                                    .map((item) => item.content)}
                                  size="small"
                                  disabled={!isEditing}
                                  onChange={(e) => {
                                    setValue("bankCode", e.target.value);
                                  }}
                                  sx={{
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      WebkitTextFillColor: process.env.REACT_APP_COLOR_DISABLE || "#9e9e9e",
                                    },
                                    ...(!isEditing && {
                                      backgroundColor: "rgba(128, 128, 128, 0.3)",
                                    }),
                                  }}

                                  InputProps={{
                                    endAdornment: (
                                      <Button
                                        variant="contained"
                                        onClick={handleClickOpen}
                                        style={{
                                          WebkitTextFillColor: process.env.REACT_APP_COLOR_CONTRAST_TEXT || "white"
                                        }}
                                        sx={{
                                          display: isEditing ? "none" : undefined,
                                          height: mobileView ? '25px' : '30px',
                                          fontSize: mobileView ? 'x-small' : '12px',
                                          whiteSpace: 'nowrap',
                                          textTransform: "none",
                                          text: "none",
                                          color: process.env.REACT_APP_COLOR_CONTRAST_TEXT || "white"
                                        }}
                                        disabled={isLock}
                                      >
                                        {t("walletcard.withdrawalpage.selectbank")}
                                      </Button>
                                    ),
                                  }}
                                />
                              )
                                : (
                                  <FormSelect
                                    label={t("walletcard.bankaccountpage.bankname")}
                                    control={control}
                                    onChange={(e) => {
                                      setValue("bankCode", e.target.value);
                                    }}
                                    controllerName="bankCode"
                                    items={bankDetails?.result?.bankConfigs
                                      .map((item) => item.bankCode)}
                                    size="small"
                                  />
                                )
                            }

                            {getValues("bankCode") === "ESEWA" && (
                              <Typography color={process.env.REACT_APP_COLOR_TEXT || "white"} variant="body2">
                                {t("walletcard.withdrawalpage.esewaWarning")}<br />
                                {t("walletcard.withdrawalpage.esewaWarning2")}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                        <Grid mt={1} container alignItems="center" spacing={2}>
                          <Grid item xs={2.5}>
                            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                              fontSize: "11px"
                            }}>
                              {t("walletcard.withdrawalpage.bankaccountname")}
                            </Typography>
                          </Grid>

                          <Grid item xs>
                            <FormTextField
                              control={control}
                              controllerName="bankAccountName"
                              disabled
                              sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                  WebkitTextFillColor: process.env.REACT_APP_COLOR_DISABLE || "#9e9e9e",
                                },
                                backgroundColor: "rgba(128, 128, 128, 0.3)",
                              }}
                              size="small"

                            />
                          </Grid>
                        </Grid>

                        <Grid mt={1} container alignItems="center" spacing={2}>
                          <Grid item xs={2.5}>
                            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                              fontSize: "11px"
                            }}>
                              {t("walletcard.withdrawalpage.bankaccountnumber")}
                            </Typography>
                          </Grid>

                          <Grid item xs>
                            <FormTextField
                              control={control}
                              controllerName="bankAccountNo"
                              size="small"
                              sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                  WebkitTextFillColor: process.env.REACT_APP_COLOR_DISABLE || "#9e9e9e",
                                },
                                ...(!isEditing || bankAccountUseMobile ? {
                                  backgroundColor: "rgba(128, 128, 128, 0.3)",
                                } : {}),
                              }}
                              disabled={!isEditing || bankAccountUseMobile}
                            />
                          </Grid>
                        </Grid>

                        {bankBsbEnabled && (
                          <Grid mt={1} container alignItems="center" spacing={2}>
                            <Grid item xs={2.5}>
                              <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                                fontSize: "11px"
                              }}>
                                {t("walletcard.withdrawalpage.bankaccountbsb")}
                              </Typography>
                            </Grid>

                            <Grid item xs>
                              <FormTextField
                                control={control}
                                controllerName="bankAccountBsb"
                                size="small"
                                sx={{
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: process.env.REACT_APP_COLOR_DISABLE || "#9e9e9e",
                                  },
                                  ...(!isEditing ? {
                                    backgroundColor: "rgba(128, 128, 128, 0.3)",
                                  } : {}),
                                }}
                                disabled={!isEditing}
                              />
                            </Grid>
                          </Grid>
                        )}

                        <Grid mt={1} container alignItems="center" spacing={2}>
                          <Grid item xs={2.5}>
                            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                              fontSize: "11px"
                            }}>
                              {t("walletcard.withdrawalpage.amount")}
                            </Typography>
                          </Grid>

                          <Grid item xs>
                            <FormTextField
                              control={control}
                              controllerName="amount"
                              defaultValue={""}
                              disabled={isLock}
                              placeholder={`Min ${minAmount || 50.00}`}
                              size="small"
                            />
                          </Grid>
                        </Grid>

                        {
                          mobileView ? (
                            <Box
                              sx={{
                                position: "fixed",
                                bottom: 55,
                                left: 0,
                                right: 0,
                                px: 3,
                                zIndex: 2,
                                py: 1.2,
                                boxShadow: "0px -4px 14px rgba(0, 0, 0, 0.6)",
                                backgroundColor: "#4A4A4A",
                              }}
                            >
                              <Button
                                fullWidth={mobileView}
                                variant="contained"
                                type="submit"
                                disabled={isLoading || isLock}
                                sx={{
                                  fontSize: mobileView ? "small" : undefined,
                                  fontWeight: "bold",
                                }}
                              >
                                {t("walletcard.submit")}
                              </Button>
                            </Box>
                          ) : (

                            <Grid container alignItems="center" spacing={2}>
                              <Grid item xs={2.5}>
                              </Grid>
                              <Grid item xs>
                                <Box alignSelf="center"
                                  mt={mobileView ? "20px" : "30px"}
                                >
                                  <Button variant="contained" type="submit"
                                    disabled={isLoading || isLock}
                                    sx={{
                                      width: mobileView ? "100%" : undefined,
                                      fontSize: mobileView ? "small" : undefined,
                                      fontWeight: "bold"
                                    }}>
                                    {t("walletcard.submit")}
                                  </Button>
                                </Box>
                              </Grid>
                            </Grid>

                          )
                        }
                      </form>
                    </Box>
                  </TabPanel>
                </Box>
                {
                  withdrawDesc && withdrawDesc?.result && (
                    <Box sx={{
                      width: "35%",
                      display: "block",
                    }}>
                      <Box sx={{
                        py: 1,
                        px: 2.5,
                        border: 1,
                        borderColor: process.env.REACT_APP_COLOR_TEXT || "white",
                        borderRadius: 2,
                        boxShadow: 15,
                      }}>
                        <Typography
                          dangerouslySetInnerHTML={{ __html: withdrawDesc?.result }}
                        />
                      </Box>
                    </Box>
                  )
                }
              </Box>
            </>
          )
        }
        <Container
          sx={{
            border: '1px solid #ccc',
            borderRadius: 4,
            py: 1.5,
            px: 2,
            mt: mobileView ? "20px" : "30px",
            mb: mobileView ? "50px" : undefined,
          }}>
          <Typography
            fontSize={mobileView ? "medium" : undefined}
            color={theme.palette.secondary.accent}
            mb={0.5}>
            {t("walletcard.withdrawalpage.withdrawalLimit")}
          </Typography>
          {withdrawalLimit.map((item, index) => (
            <Grid container key={index} spacing={2} >
              <Grid item xs={6}>
                <Typography fontSize={mobileView ? "x-small" : undefined}
                  color={process.env.REACT_APP_COLOR_TEXT || "white"}>{item.label}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography fontSize={mobileView ? "x-small" : undefined}
                  color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right">{item.value}</Typography>
              </Grid>
            </Grid>
          ))}
        </Container>
      </>
    </Container >
  );
};

export default Withdrawal;
